module.exports = __webpack_public_path__ + "static/media/BasisGrotesqueProWinnowBeta12-Regular.2687f371.woff2";